import React, { useEffect } from "react";
import { AppText } from "@toothfairy/shared-ui";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import { View, Platform } from "react-native";
import { displayedToasties } from "../../../App";

const ToothFairyToast = ({
  type,
  successColor,
  dangerColor,
  warningColor,
  message,
  showTitle = false,
  ...props
}) => {
  const { currentTheme } = AppTheme.useTheme();

  const getToastConfig = () => {
    switch (type) {
      case "success":
        return {
          backgroundColor: currentTheme?.theme?.green || "#10B981",
          shadowColor: currentTheme?.theme?.green || "#10B981",
          borderColor: "#34D399",
        };
      case "danger":
        return {
          backgroundColor: currentTheme?.theme?.red || "#EF4444",
          shadowColor: currentTheme?.theme?.red || "#EF4444",
          borderColor: "#F87171",
        };
      case "warning":
        return {
          backgroundColor: currentTheme?.theme?.orange || "#F59E0B",
          shadowColor: currentTheme?.theme?.orange || "#F59E0B",
          borderColor: "#FBBF24",
        };
      default:
        return {
          backgroundColor: currentTheme?.theme?.gray || "#6B7280",
          shadowColor: currentTheme?.theme?.gray || "#6B7280",
          borderColor: "#9CA3AF",
        };
    }
  };

  const config = getToastConfig();

  useEffect(() => {
    return () => {
      displayedToasties(null);
    };
  }, []);

  return (
    <View
      style={{
        marginHorizontal: "auto",
        backgroundColor: config.backgroundColor,
        marginTop: 12,
        paddingVertical: 5,
        paddingHorizontal: 10,
        borderRadius: 12,
        alignItems: "center",
        alignContent: "center",
        minWidth: 160,
        maxWidth: "90%",
        zIndex: 1000,
        ...Platform.select({
          ios: {
            shadowColor: config.shadowColor,
            shadowOffset: { width: 0, height: 4 },
            shadowOpacity: 0.15,
            shadowRadius: 12,
          },
          android: {
            elevation: 8,
          },
          web: {
            boxShadow: `0 4px 20px rgba(0, 0, 0, 0.1)`,
          },
        }),
        borderWidth: 1,
        borderColor: "rgba(255, 255, 255, 0.15)",
        backdropFilter: Platform.OS === "web" ? "blur(10px)" : undefined,
      }}
    >
      {showTitle && (
        <AppText
          fontWeight="600"
          style={{
            fontSize: currentTheme?.theme?.medium_font_size || 16,
            textTransform: "capitalize",
            letterSpacing: 0.3,
          }}
          color={currentTheme?.theme?.white || "#FFFFFF"}
          wrapperStyle={{
            marginBottom: 6,
          }}
        >
          {type}
        </AppText>
      )}

      <AppText
        fontWeight="500"
        style={{
          fontSize: currentTheme?.theme?.small_font_size || 14,
          lineHeight: 20,
          textAlign: "center",
          letterSpacing: 0.2,
        }}
        color={currentTheme?.theme?.white || "#FFFFFF"}
      >
        {message}
      </AppText>
    </View>
  );
};

export default ToothFairyToast;
